import { render, staticRenderFns } from "./monkeyKing.vue?vue&type=template&id=509f88f8&scoped=true"
import script from "./monkeyKing.vue?vue&type=script&lang=js"
export * from "./monkeyKing.vue?vue&type=script&lang=js"
import style0 from "./monkeyKing.vue?vue&type=style&index=0&id=509f88f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f88f8",
  null
  
)

export default component.exports